<!-- 添加证书页面 -->
<template>
    <div>
        <div style="font-size: 20px;margin: 12px;color: #333333;">上传更多信息有助于审核通过</div>
        <div style="font-size: 16px; margin: 12px;color: #333333">毕业证/学位证/培训证等在校经历证明</div>
        <div style="width: 80% ;margin: 10px auto;">
            <img class="bigImg" src="./images/btn_shangchuan_nor@3x.png" @click="loadImg" v-if="fileData.file == ''">
            <img class="bigImg" :src="fileData.file" v-else>
        </div>

        <div style="height: 250px;"></div>
        <div style="text-align: center;">
            <el-button style="margin:auto;" class="lwork" type="primary" @click="commit">提交</el-button>
        </div>

        <!-- 弹窗 -->
        <van-action-sheet v-model="drawer" @select="onSelect" cancel-text="取消" close-on-click-action
            @cancel="drawer = false">
            <van-uploader :before-read="beforeRead" :after-read="afterRead">
                <div class="selectPhoto">从相册选择</div>
            </van-uploader>
        </van-action-sheet>

    </div>
</template>

<script>
export default {
    data() {
        return {
            drawer: false,
            fileData: {
                userId: window.localStorage.getItem("user_id"),
                file: "",
            },
            fileUplode: '',
        }
    },
    methods: {
        // 审核材料必须上传
        async commit() {
            if (this.fileData.file === '') {
                this.$toast("请上传证明")
            } else {
                let param = new window.FormData();
                param.append("file", this.fileUplode.file);
                param.append("userId", this.fileData.userId);
                const result = await this.$http.post("/xjcard/humanReview", param);
                if (result.data.msg == "上传成功") {
                    await this.$router.push("/contactStaff")
                } else {
                    this.$toast("提交失败")
                    return
                }
            }
        },
        loadImg(index) {
            this.drawer = true;
        },
        onSelect() {
            this.show = false;
        },
        beforeRead(file) {
            if (file.type !== "image/jpeg" && file.type !== "image/png") {
                this.$toast("请上传 jpg,png 格式图片");
                return false;
            }
            return true;
        },
        async afterRead(file) {
            console.log(file)
            this.fileData.file = file.content
            this.fileUplode = file
        },
    }
}

</script>

<style lang="less">
.lwork {
    background-color: #00706E;
    text-align: center;
    width: 80% !important;
    border-radius: 35px;
    display: block;
    height: 35px;
    font-size: 20px;
    color: #fff;
    margin: 0 auto;
    padding: 0;
}

// 上传图片
.bigImg {
    height: 186px;
    width: 100%;
    margin: 8px auto;
    // width: 80%;
}

.el-upload--picture-card {
    height: 0px;
    width: 0px;
}

// icon
.van-uploader__upload-icon {
    font-size: 52px;
}

.van-uploader__preview-image {
    height: 186px;
    width: 300px;
}

.preview-cover .van-ellipsis {}

.van-uploader__upload {
    height: 186px;
    width: 300px;
    margin: 8px auto;
    border: dashed 2px #333333;
    // border-style: dotted;
}

.preview-cover {
    position: absolute;
    bottom: 0;
    box-sizing: border-box;
    // width: 100%;
    width: 300px;
    height: 186px;
    padding: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, 0.3);
}

// 弹出层
.el-drawer__header {
    margin: 4px;
    padding: 0%;
}

.el-drawer__open .el-drawer.btt {
    border-radius: 30px 30px 0 0;
}

// .com-item{
//     text-align: center;
//     width: 100%;
//     padding: 15px;
//     color: #333333;
//     font-size: 20px;
// }
.el-button--primary {
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    margin: auto;
}

.el-button+.el-button {
    margin: auto;
}

.selectPhoto {
    font-size: 1.2rem;
    font-weight: 400;
    color: #00706E;
    margin: 20px 0;
}

.van-uploader {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/IdentitAuthentication/addCertification.vue